<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Dropzones from "./Dropzones.svelte";
  import Emoji from "@helpers/Emoji.svelte";

  let element;
  export let intersecting = false;
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="blocks">
    <div class="prose">
      <h1 class="section-title">
        <span class="accent-text">
          <span class="emoji-follows"
            ><Emoji emoji="bricks" styles="left: -50%; top: -15%;" />Build</span
          > your own</span
        > budget
      </h1>
      <p class="body-text">
        Now that you know what your money goes toward, how would you like to
        distribute it?
        <!-- A budget is much more than just deciding what's
        important to you. It's also about figuring out how those values
        translate to the money you allocate. -->
      </p>
      <p class="body-text">
        Let's imagine a simplified version of the Houston budget with only these
        4 departments and 10 “budget blocks.”
      </p>
      <p class="direction-text">
        Move each of the blocks into a department. More blocks means you want
        more funding for that department.
      </p>
    </div>
    <Dropzones />
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    /* margin: 0 auto 5rem auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    /* min-height: 100vh; */
    /* background: rgb(245, 166, 35); */
  }

  .emoji-follows:before {
    top: -0.5rem;
    right: -4.25rem;
  }
</style>
